import { api, ApiRequestConfig } from 'api';
import { FetchModelProps, ModelJson } from 'features/page-model/types';

export type GetModelParams = {
  host: string;
  params: FetchModelProps;
  config?: ApiRequestConfig;
};

export const getModel = async ({ host, params, config }: GetModelParams) =>
  api.get<ModelJson, FetchModelProps>(`${host}/getModel`, params, config);
